import {Button} from "reactstrap";
import { ReactComponent as DownloadIcon } from "@src/assets/images/tournament/download.svg";
import {formatImageSrc} from "@utils";

export const DownloadPassportButton = ({passport}) => {
    return (
        <a
            href={formatImageSrc(passport)}
            download="Passport"
            target="_blank"
            className={'p-0'}
        >
            <Button
                className={
                    "d-flex height-65 justify-content-between align-items-center mt-1 px-1 mb-1 text-white"
                }
                type={'button'}
                size={"lg"}
                outline
                block
            >
                Download Passport Document
                <DownloadIcon
                    width={40}
                    height={40}
                    className={"bg-secondary rounded-3"}
                />
            </Button>
        </a>
    )
}